export default function SeparatorText({ label }: { label: string }) {
  return (
    <div className="flex w-full items-center">
      <hr className="w-full text-gray dark:text-neutral-600" />
      <div className="px-4 text-base text-gray dark:text-neutral-600">{label}</div>
      <hr className="w-full text-gray dark:text-neutral-600" />
    </div>
  );
}
